import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Logo from 'gatsby-theme-core/src/components/logo';

const PdVLogo = ({ className }) => {
  const { company } = useStaticQuery(graphql`
    query PdVLogoStrapiCompanyQuery {
      company: strapiCompanyCompany {
        logo {
          name
          url
          width
          height
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: FIXED
                width: 76
                placeholder: BLURRED
              )
            }
          }
        }
      }
    }
  `);

  return <Logo image={company.logo} className={className} />;
};

const StyledLogo = styled(PdVLogo)`
  width: 60px;
  height: auto;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    width: 76px;
  }
`;

export default styled(StyledLogo)``;
